import {
  evaluateCondition,
  evaluateConditionGroup,
  evaluateNestedConditionExpression,
} from './condition-evaluator';

/**
 * Options for getActiveState
 */
export interface GetActiveStateOptions<TState> {
  states: TState[];
}

export const getActiveState = <
  TState extends { conditionExpression?: any; isDefault?: boolean; priority?: number },
>({
  states,
}: GetActiveStateOptions<TState>): TState | undefined => {
  return states
    ?.filter((state) => {
      if (!state.conditionExpression) {
        return state.isDefault || false;
      } else if (state.isDefault) {
        // when there is a condition but it is marked as default.
        return true;
      } else {
        // Evaluate the condition expression
        const conditionExpression = state.conditionExpression;

        if (conditionExpression.condition) {
          return evaluateCondition(conditionExpression.condition);
        }

        if (conditionExpression.conditionGroup) {
          return evaluateConditionGroup(conditionExpression.conditionGroup);
        }

        if (conditionExpression.nestedExpression) {
          return evaluateNestedConditionExpression(conditionExpression.nestedExpression);
        }

        return false;
      }
    })
    ?.sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0))?.[0];
};
